// extracted by mini-css-extract-plugin
export var alignCenter = "_8g-d";
export var bannerShown = "_8g-6";
export var buttonContent = "_8g-0";
export var cardList = "_8g-1";
export var centerContent = "_8g-2";
export var chevron = "_8g-3";
export var closePanelButton = "_8g-k";
export var conversationContextContainer = "_8g-l";
export var conversationDetailContainer = "_8g-4";
export var detailWrapper = "_8g-7";
export var dropdownButton = "_8g-e";
export var dropdownTitle = "_8g-9";
export var fullHeight = "_8g-5";
export var hidden = "_8g-a";
export var icon = "_8g-b";
export var mergeSuggestionWrapper = "_8g-m";
export var panel = "_8g-i";
export var portalButtonsWrapper = "_8g-c";
export var right = "_8g-j";
export var tableSummaryContainer = "_8g-8";
export var tableSummaryHeader = "_8g-g";
export var threeDotsButton = "_8g-f";
export var wide = "_8g-h";